import { lazier } from '@shared/components';

import AdvancementPagePlaceholder from './AdvancementPagePlaceholder';

export { AdvancementPagePlaceholder };

export const AdvancementPage = lazier(
  () => import('./AdvancementPage'),
  AdvancementPagePlaceholder,
);
